import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import AdminSidebar from "../shared/AdminSidebar";
import { getNodeApiBase } from "../../../utils/apiBase";

const GridEvaluationList = () => {
  const [grids, setGrids] = useState([]);
  const nodeApiBase = getNodeApiBase();

  useEffect(() => {
    const apiBase = nodeApiBase;

    const load = async () => {
      try {
  const resp = await fetch(`${apiBase}/api/evaluation/list`);
        const json = await resp.json();
        const list = Array.isArray(json?.data) ? json.data : [];
        setGrids(list);
      } catch (e) {
        console.error("Failed to fetch evaluations:", e);
        setGrids([]);
      }
    };

    load();
  }, [nodeApiBase]);

  const handleDelete = (id) => {
    if (!window.confirm("Supprimer cette grille ?")) return;
    setGrids((prev) => prev.filter((g) => String(g.ID_Evaluation) !== String(id)));
    // Note: backend delete not implemented yet; this updates the UI only for now.
  };

  const actionBtn = (bg) => ({
    padding: "6px 10px",
    border: "none",
    borderRadius: "6px",
    color: "#fff",
    cursor: "pointer",
    background: bg,
    display: "inline-flex",
    alignItems: "center",
    whiteSpace: "nowrap",
  });

  const layoutStyle = {
    marginLeft: "250px",
    width: "calc(100vw - 250px)",
    minHeight: "100vh",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    background: "#e4d2d2",
    padding: "40px 20px",
    boxSizing: "border-box",
  };

  const cardStyle = {
    width: "100%",
    maxWidth: "1100px",
    background: "#fff",
    border: "1px solid #e6e8eb",
    borderRadius: "12px",
    boxShadow: "0 8px 16px rgba(16,24,40,0.08)",
    overflow: "hidden",
  };

  const headerBarStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#0b7a3e",
    color: "#fff",
    padding: "14px 20px",
    fontWeight: 800,
    fontSize: "1.25rem",
  };

  const bodyStyle = { padding: "20px" };

  const createBtnStyle = {
    background: "#fff",
    color: "#0b7a3e",
    border: "1px solid #d0d5dd",
    borderRadius: "8px",
    padding: "8px 12px",
    fontWeight: 700,
    cursor: "pointer",
    textDecoration: "none",
  };

  const tableShellStyle = {
    border: "1px solid #e6e8eb",
    borderRadius: "10px",
    overflow: "hidden",
    background: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  };

  const thStyle = { padding: 12, textAlign: "left", borderBottom: "1px solid #e6e8eb", background: "#0d6efd", color: "#fff" };
  const tdStyle = { padding: 12, borderTop: "1px solid #f1f3f5", verticalAlign: "top", whiteSpace: "normal", wordBreak: "break-word" };
  const tdActionsStyle = { ...tdStyle, whiteSpace: "nowrap", verticalAlign: "middle" };

  return (
    <>
      <AdminSidebar />

      <div style={layoutStyle}>
        <div style={cardStyle}>
          <div style={headerBarStyle}>
            <span>Grilles d’évaluation</span>
            <Link to="/grid-evaluation-new" style={createBtnStyle}>
              Créer une grille d’évaluation
            </Link>
          </div>
          <div style={bodyStyle}>
            <div style={tableShellStyle}>
              <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                <thead>
                  <tr>
                    <th style={thStyle}>Titre</th>  
                    <th style={thStyle}>Date</th>
                    <th style={thStyle}>Critères</th>
                    <th style={thStyle}>Sous-critères</th>
                    <th style={thStyle}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {grids.length === 0 ? (
                    <tr>
                      <td colSpan={5} style={{ padding: 12, textAlign: "center", color: "#6b7280" }}>
                        Aucune grille enregistrée
                      </td>
                    </tr>
                  ) : (
                    grids.map((g) => {
                      const crits = Array.isArray(g.criteria) ? g.criteria : [];
                      const critTitles = crits
                        .map((c) => (c?.Titre_criteres ?? ""))
                        .filter(Boolean)
                        .join(", ");
                      const allSubs = crits
                        .flatMap((c) => Array.isArray(c.subCriteria) ? c.subCriteria.map((s) => s?.Titre_sous_critres ?? "") : [])
                        .filter(Boolean);
                      return (
                        <tr key={g.ID_Evaluation}>
                          <td style={tdStyle}>{g.Titre_evaluation}</td>
                          <td style={tdStyle}>{"-"}</td>
                          <td style={tdStyle}>{critTitles || "-"}</td>
                          <td style={tdStyle}>{allSubs.length ? allSubs.join(", ") : "-"}</td>
                          <td style={tdActionsStyle}>
                            <div style={{ display: "flex", gap: 8, flexWrap: "nowrap", alignItems: "center" }}>
                              <Link to={`/grid-evaluation-edit/${g.ID_Evaluation}`} style={{ textDecoration: "none", display: "inline-block" }}>
                                <button type="button" style={actionBtn("#0d6efd")}>Modifier</button>
                              </Link>
                              <button type="button" style={actionBtn("#dc3545")} onClick={() => handleDelete(g.ID_Evaluation)}>
                                Supprimer
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GridEvaluationList;
